import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["id", "type"];
import React, { useState } from "react";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import { Alert, Box, Text } from "@catchoftheday/cg-components";
import { DEFAULT_ALERT_TIMEOUT, GENERIC_ERROR } from "../../../consts/index.js";
import { useSavedPaymentMethodsQuery } from "../../../generated/graphql.jsx";
import { StripeElementsProvider } from "../../pure/stripe/StripeElementsProvider/StripeElementsProvider.jsx";
import { StripeTrustBadge } from "../../pure/stripe/StripeTrustBadge/StripeTrustBadge.jsx";
import { SavedCardContainer } from "../saved-card/SavedCardContainer/SavedCardContainer.jsx";
import { SavedCardFormContainer } from "../saved-card/SavedCardFormContainer/SavedCardFormContainer.jsx";
import { SavedPaymentMethodsPlaceholder } from "./SavedPaymentMethodsPlaceholder.jsx";
import { formatPaymentMethods } from "./utils.js";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SavedPaymentMethodsContainer = function SavedPaymentMethodsContainer() {
  var stripe = useStripe();
  var elements = useElements();

  var _useSavedPaymentMetho = useSavedPaymentMethodsQuery({
    onCompleted: function onCompleted(_ref) {
      var customer = _ref.customer;

      if (customer) {
        var paymentDetails = customer.paymentDetails;

        var _paymentMethods = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.savedPaymentMethods;

        _paymentMethods && setPaymentMethods(_paymentMethods);
        (_paymentMethods === null || _paymentMethods === void 0 ? void 0 : _paymentMethods.length) === 0 && setPaymentMethodForm({
          visible: true,
          type: "CREDIT_CARD"
        });
      }
    }
  }),
      paymentMethodsLoading = _useSavedPaymentMetho.loading,
      paymentMethodsError = _useSavedPaymentMetho.error;

  var _useState = useState([]),
      paymentMethods = _useState[0],
      setPaymentMethods = _useState[1];

  var _useState2 = useState(null),
      alert = _useState2[0],
      setAlert = _useState2[1];

  var _useState3 = useState({
    visible: false
  }),
      paymentMethodForm = _useState3[0],
      setPaymentMethodForm = _useState3[1];

  if (paymentMethodsLoading || !stripe || !elements) {
    return ___EmotionJSX(SavedPaymentMethodsPlaceholder, {
      rows: 3
    });
  }

  if (paymentMethodsError) {
    return ___EmotionJSX(Alert, {
      type: "inline",
      variant: "error",
      fontSize: "base"
    }, GENERIC_ERROR);
  }

  return ___EmotionJSX(Box, {
    pb: {
      xs: 6,
      md: 8
    }
  }, alert && ___EmotionJSX(Alert, _extends({
    type: "inline",
    theme: "dark",
    fontSize: "base",
    wrapperProps: {
      mb: 6
    },
    showCloseButton: true,
    timeoutDuration: DEFAULT_ALERT_TIMEOUT,
    hideAlert: function hideAlert() {
      return setAlert(null);
    }
  }, alert), alert.message), ___EmotionJSX(Box, {
    width: {
      xs: "100%",
      lg: "50%"
    }
  }, paymentMethodForm.visible ?
  /* #region Forms for adding and updating Payment Methods */
  ___EmotionJSX(React.Fragment, null, paymentMethodForm.type === "CREDIT_CARD" && ___EmotionJSX(SavedCardFormContainer, {
    paymentMethodId: paymentMethodForm.paymentMethodId,
    setAlert: setAlert,
    setPaymentMethods: setPaymentMethods,
    setPaymentMethodForm: setPaymentMethodForm
  })) :
  /* #endregion */
  ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
    mb: 8
  }, "Safely store and manage your payment options using our secure system."), ___EmotionJSX(Box, {
    display: "grid",
    rowGap: 6
  }, formatPaymentMethods({
    paymentMethods: paymentMethods
  }).map(function (_ref2) {
    var id = _ref2.id,
        type = _ref2.type,
        paymentMethod = _objectWithoutProperties(_ref2, _excluded);

    /* #region Components for rendering payment methods */
    if (type === "CREDIT_CARD") {
      return ___EmotionJSX(SavedCardContainer, _extends({
        key: id,
        id: id,
        type: type,
        setAlert: setAlert,
        setPaymentMethods: setPaymentMethods,
        setPaymentMethodForm: setPaymentMethodForm
      }, paymentMethod));
    }

    return null;
    /* #endregion */
  })))), paymentMethodForm.visible && ___EmotionJSX(StripeTrustBadge, {
    position: {
      xs: "relative",
      lg: "absolute"
    },
    top: {
      lg: 4
    },
    right: {
      lg: 4
    }
  }));
};

var SavedPaymentMethodsContainerWithElementsProvider = function SavedPaymentMethodsContainerWithElementsProvider() {
  return ___EmotionJSX(StripeElementsProvider, null, ___EmotionJSX(SavedPaymentMethodsContainer, null));
};

export default SavedPaymentMethodsContainerWithElementsProvider;